import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { StoreInformation } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information')({
  loader: ({ context }) => {
    context.groupLabel = 'storeManagement.sidebar.group.title';
    context.childRoutes = [
      {
        id: 'storeManagement.sidebar.menu.premiumStores',
        label: 'Premium Stores',
        path: '/store-information/premium-stores/',
        icon: StoreInformation,
      },
      {
        id: 'storeManagement.sidebar.menu.basicStores',
        label: 'Basic Stores',
        path: '/store-information/basic-stores',
        icon: StoreInformation,
      },
    ];
    return {
      crumb: (
        <CrumbTitle
          title="Store Information"
          id="manageStoreInformation.basicStore.crumb.storeInformation"
          icon={StoreInformation}
        />
      ),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
